<template>
    <div>
        <menu-bar></menu-bar>

        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">

                <ol class="breadcrumb">
                    <li><a href="#/"> <i class="fa fa-home" aria-hidden="true"></i>INICIAL</a></li>
                    <li class="active"><i class="fa fa-id-card-o" aria-hidden="true"></i> ICINGA</li>
                </ol>

                <div class="col-md-12">

                    <div class="col-md-7">
                        <label class="control-label">BUSCA POR NOME</label>
                        <input type="text" v-model="nome" class="form-control" >
                    </div>

                    <div class="col-md-5">
                        <br/>
                        <blockquote class="blockquote-reverse">
                            Total de Registros: <b>{{getContratos.length}}</b>
                        </blockquote>
                    </div>

                    <div class="col-md-12" style="margin-top: 20px">

                        <table id="mytable" class="table table-bordred table-striped">

                            <thead>
                                <tr>
                                    <th>CLIENTE</th>
                                    <th>SAÍDA</th>
                                    <th style="text-align: center;width: 180px">AÇÕES</th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr v-for="r in getContratos" :class="{danger: r.attrs.state === 1}">
                                    <td style="vertical-align: middle; text-transform: uppercase">{{r.attrs.display_name}}</td>
                                    <td style="vertical-align: middle; text-transform: uppercase">{{r.attrs.last_check_result.output}}</td>
                                    <td style="text-align: center">
                                        <button type="button" @click="remove(r.attrs.__name)"  class="btn btn-primary btn-xs">
                                            EXCLUIR <i class="fa fa-angle-double-right" aria-hidden="true"></i>
                                        </button>
                                    </td>
                                </tr>
                            </tbody>

                        </table>

                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Config } from "../../class/index";

export default {
    data() {
        return {
            contratos: [],
            user: null,
            nome: null
        };
    },
    computed: {
        getContratos: function() {
            if (!this.contratos.results) {
                return [];
            }

            if (!this.nome) {
                return this.contratos.results;
            }

            return this.contratos.results.filter(player => {
                return player.attrs.display_name
                    .toLowerCase()
                    .includes(this.nome.toLowerCase());
            });
        }
    },
    methods: {
        remove(host) {
            swal.queue([
                {
                    title: "Contratos",
                    confirmButtonText: "Excluir do Icinga",
                    text: "Posso excluir do Icinga?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise((resolve, reject) => {
                            Config.removeIcinga(host)
                                .then(() => {
                                    this.load();
                                    resolve();
                                })
                                .catch(err => {
                                    console.log(err);
                                    reject();
                                });
                        });
                    }
                }
            ]);
        },
        load() {
            Config.allIcinga()
                .then(rows => (this.contratos = rows))
                .catch(err => console.log(err));
        }
    },
    beforeMount() {
        this.user = this.$store.state.user;
        this.load();
    }
};
</script>
